export default __webpack_public_path__ + "static/img36h-978664d85a58015d074009a5168f51ae.jpg";